// extracted by mini-css-extract-plugin
module.exports = {"appBar":"_-ui-admin-lib-AppBar-index-module__appBar--2fJ6a","logo":"_-ui-admin-lib-AppBar-index-module__logo--1nMB3","title":"_-ui-admin-lib-AppBar-index-module__title--1Ao1S"};